// Import all markdown files from the blog content directory
const blogFiles = import.meta.glob('/src/content/blog/*.md', {
  eager: true,
  query: '?raw',
  import: 'default'
})

// Simple frontmatter parser (browser-compatible)
function parseFrontmatter(content) {
  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/
  const match = content.match(frontmatterRegex)

  if (!match) {
    return { data: {}, content }
  }

  const frontmatterStr = match[1]
  const markdown = match[2]

  // Parse YAML-like frontmatter
  const data = {}
  const lines = frontmatterStr.split('\n')

  for (const line of lines) {
    const colonIndex = line.indexOf(':')
    if (colonIndex > 0) {
      const key = line.slice(0, colonIndex).trim()
      let value = line.slice(colonIndex + 1).trim()

      // Remove quotes if present
      if ((value.startsWith('"') && value.endsWith('"')) ||
          (value.startsWith("'") && value.endsWith("'"))) {
        value = value.slice(1, -1)
      }

      // Parse booleans
      if (value === 'true') value = true
      else if (value === 'false') value = false

      data[key] = value
    }
  }

  return { data, content: markdown }
}

// Parse all blog posts
export function getAllPosts() {
  const posts = Object.entries(blogFiles).map(([filepath, content]) => {
    const { data, content: markdown } = parseFrontmatter(content)
    const slug = data.slug || filepath.split('/').pop().replace('.md', '')

    return {
      ...data,
      slug,
      content: markdown,
    }
  })

  // Sort by date, newest first
  return posts.sort((a, b) => new Date(b.date) - new Date(a.date))
}

// Get a single post by slug
export function getPostBySlug(slug) {
  const posts = getAllPosts()
  return posts.find(post => post.slug === slug)
}

// Get posts by category
export function getPostsByCategory(category) {
  const posts = getAllPosts()
  if (!category || category === 'All') return posts
  return posts.filter(post => post.category === category)
}

// Get all unique categories
export function getAllCategories() {
  const posts = getAllPosts()
  const categories = [...new Set(posts.map(post => post.category))]
  return ['All', ...categories]
}

// Get featured posts
export function getFeaturedPosts() {
  const posts = getAllPosts()
  return posts.filter(post => post.featured)
}

// Format date for display
export function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
